// Mirror of backend/routes/settings.py::_normalize / match_tag.
// Kept intentionally simple so it stays trivially in-sync with the Python side.
// If the backend rule changes, update both.

export function normalizePattern(input) {
  const lowered = (input || "").toLowerCase();
  const tokens = lowered.split(/\s+/).filter(Boolean);
  const normalized = tokens.map((tok) => (/\d/.test(tok) ? "#" : tok));
  // Collapse consecutive '#' tokens
  const collapsed = [];
  for (const tok of normalized) {
    if (tok === "#" && collapsed[collapsed.length - 1] === "#") continue;
    collapsed.push(tok);
  }
  return collapsed.join(" ");
}

export function matches(pattern, description) {
  const np = normalizePattern(pattern);
  const nd = normalizePattern(description);
  if (!np || !nd) return false;
  return nd.includes(np);
}
